import type { FC, SVGProps } from "react"

const FooterFacebook: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 10.0608C20 4.53829 15.5225 0.060791 10 0.060791C4.4775 0.060791 0 4.53829 0 10.0608C0 15.0525 3.65667 19.1891 8.4375 19.9391V12.9516H5.89833V10.06H8.4375V7.85829C8.4375 5.35246 9.93083 3.96746 12.215 3.96746C13.3083 3.96746 14.4533 4.16329 14.4533 4.16329V6.62412H13.1917C11.9492 6.62412 11.5617 7.39496 11.5617 8.18579V10.0608H14.335L13.8917 12.9525H11.5617V19.94C16.3433 19.1891 20 15.0516 20 10.0608Z"
      fill="#8B8987"
    />
  </svg>
)

export default FooterFacebook
